import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const Notiser = lazy(() => import("@/pages/mina-sidor/Notiser"));

export const Route = createFileRoute("/mina-sidor/notiser")({
  head: () => ({
    meta: [
      { title: "Notiser » Prisnotiser via e-post – Elmarknad.se" },
      {
        name: "description",
        content:
          "Prenumerera kostnadsfritt på notiser om elpriser via e-post. Få mejl när morgondagens spotpriser släpps eller när priset passerar din gräns.",
      },
      { property: "og:title", content: "Notiser » Prisnotiser via e-post – Elmarknad.se" },
      {
        property: "og:description",
        content: "Skapa egna prisnotiser för SE1–SE4 och få dem gratis via e-post.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: () => <Notiser />,
});
